import { MapPin, Mail, Phone } from "lucide-react";
import { ORG } from "@/lib/constants";
import { ContactForm } from "@/components/forms/ContactForm";
import { SocialIcons } from "@/components/SocialIcons";
import { Reveal } from "@/components/Reveal";

export function ContactSection() {
  return (
    <section id="contact" className="relative py-20 sm:py-28 lg:py-32 bg-ink-900 overflow-hidden">
      <div className="absolute inset-0 court-glow opacity-70" />
      <div className="container-x relative">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <Reveal>
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-blaze-orange">Get In Touch</span>
              <h2 className="mt-3 font-display font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
                Contact <span className="text-gradient-blaze">Us</span>
              </h2>
              <p className="mt-5 text-lg text-white/70 leading-relaxed max-w-md">
                Questions about tryouts, clinics or training? Send us a message and a CT BLAZERS coach will get back to you.
              </p>
            </Reveal>

            <div className="mt-8 space-y-4">
              <Reveal delay={0.05}>
                <div className="flex items-center gap-4 rounded-xl border border-white/10 bg-ink-700/60 p-4">
                  <div className="grid h-11 w-11 place-items-center rounded-lg bg-blaze-blue/15 text-blaze-blueLight">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/50">Location</p>
                    <p className="text-white font-semibold">{ORG.city}</p>
                  </div>
                </div>
              </Reveal>
              <Reveal delay={0.1}>
                <a
                  href={`mailto:${ORG.email}`}
                  data-testid="contact-email-link"
                  className="flex items-center gap-4 rounded-xl border border-white/10 bg-ink-700/60 p-4 hover:border-blaze-orange/40 transition-colors"
                >
                  <div className="grid h-11 w-11 place-items-center rounded-lg bg-blaze-blue/15 text-blaze-blueLight">
                    <Mail size={20} />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/50">Email</p>
                    <p className="text-white font-semibold break-all">{ORG.email}</p>
                  </div>
                </a>
              </Reveal>
              <Reveal delay={0.15}>
                <a
                  href="tel:+12034148688"
                  data-testid="contact-phone-link"
                  className="flex items-center gap-4 rounded-xl border border-white/10 bg-ink-700/60 p-4 hover:border-blaze-orange/40 transition-colors"
                >
                  <div className="grid h-11 w-11 place-items-center rounded-lg bg-blaze-blue/15 text-blaze-blueLight">
                    <Phone size={20} />
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-white/50">Phone</p>
                    <p className="text-white font-semibold">(203) 414-8688</p>
                  </div>
                </a>
              </Reveal>
              <Reveal delay={0.2}>
                <div className="pt-2">
                  <p className="text-xs uppercase tracking-wider text-white/50 mb-3">Follow CT Blazers</p>
                  <SocialIcons />
                </div>
              </Reveal>
            </div>
          </div>

          <Reveal delay={0.1}>
            <div className="rounded-2xl border border-white/10 bg-ink-700/70 p-6 sm:p-8 shadow-2xl">
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
